import { GroupSessionsFormInitializer } from '../components/form/GroupSessionsForm.types';

export const formInitializer: GroupSessionsFormInitializer = () => ({
   type: 'CLOSED',
});
